import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => {
    const ACCORDION_BORDER = `1px solid ${theme.colors.gray[200]}`;
    const ACCORDION_BORDER_RADIUS = 5;
    return {
        root: {
            boxShadow: 'none',
            border: ACCORDION_BORDER,
            borderBottom: 'none',
            '&::before': {
                display: 'none',
            },
            '&:last-child': {
                borderBottom: ACCORDION_BORDER,
            },
            '&.Mui-expanded': {
                marginTop: 0,
                borderBottom: ACCORDION_BORDER,
                '& .MuiDivider-root': {
                    opacity: 1,
                },
            },
            '&.MuiAccordion-rounded': {
                '&:first-child': {
                    borderTopLeftRadius: ACCORDION_BORDER_RADIUS,
                    borderTopRightRadius: ACCORDION_BORDER_RADIUS,
                },
                '&:last-child': {
                    borderBottomLeftRadius: ACCORDION_BORDER_RADIUS,
                    borderBottomRightRadius: ACCORDION_BORDER_RADIUS,
                },
            },
            '& .MuiDivider-root': {
                opacity: 0,
            },
        },
        summary: {
            flexDirection: 'row-reverse',
        },
        summaryExpandIcon: {
            marginLeft: -14,
            marginRight: 0,
            padding: 18,
            '& svg': {
                fontSize: 20,
                fill: theme.colors.primary.main,
            },
        },
        summaryLeftColumn: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        summaryRightColumn: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        summaryWrapper: {
            flex: 1,
        },
        summaryTitle: {
            fontWeight: 600,
        },
        summaryDescription: {
            marginTop: 5,
            color: theme.colors.text[600],
        },
        details: Object.assign({ padding: 16 }, theme.typography.body1),
        actions: {
            padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
            borderTop: `1px solid ${theme.colors.gray[200]}`,
        },
        notClickable: {
            pointerEvents: 'none',
        },
    };
});
//# sourceMappingURL=Accordion.styles.js.map